// extracted by mini-css-extract-plugin
export default {"container":"Y9lnN1u","message":"VAwbzdY fVdHxMU"};